"use client";

import { motion } from "framer-motion";

function SkeletonBlock({ className }: { className: string }) {
  return (
    <motion.div
      className={`rounded-md bg-zinc-300/80 dark:bg-zinc-800/70 ${className}`}
      animate={{ opacity: [0.45, 0.75, 0.45] }}
      transition={{ repeat: Infinity, duration: 1.4, ease: "easeInOut" }}
    />
  );
}

export function DiscoverySkeletonGrid() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {Array.from({ length: 4 }).map((_, index) => (
        <article key={`skeleton-${index}`} className="rounded-2xl border border-zinc-300 bg-white/80 p-5 dark:border-zinc-800 dark:bg-zinc-900/70">
          <div className="flex items-center justify-between gap-3">
            <SkeletonBlock className="h-5 w-1/2" />
            <SkeletonBlock className="h-6 w-20 rounded-full" />
          </div>
          <SkeletonBlock className="mt-4 h-4 w-3/4" />
          <SkeletonBlock className="mt-3 h-4 w-full" />
          <SkeletonBlock className="mt-2 h-4 w-5/6" />

          <div className="mt-4 flex gap-2">
            <SkeletonBlock className="h-6 w-24" />
            <SkeletonBlock className="h-6 w-28" />
          </div>

          <div className="mt-6 flex gap-3">
            <SkeletonBlock className="h-9 w-28" />
            <SkeletonBlock className="h-9 w-20" />
          </div>
        </article>
      ))}
    </div>
  );
}
